/* eslint-disable */
import {
  Button,
  Divider,
  Dropdown,
  Icon,
  Layout,
  Menu,
  Modal,
  Row,
  Table,
  Tooltip,
  Switch,
  Breadcrumb,
  PageHeader,
  Spin,
} from "antd";
import axios from "axios";
import moment from "moment";
import qs from "qs";
import React, { Component } from "react";
import Moment from "react-moment";
import { connect } from "react-redux";
import { Constant } from "../../config";
import services from "./services";
import { fetchMenuAction } from "../../store/actions/leftSideMenu";
import MyModal from "../Modal";
import GatewayCountryModal from "./GatewayCountryModal";
import MemberCountryRestrictionsModal from "./MemberCountryRestrictionsModal";
import Search from "./search";
import SendersModal from "./UserManagement/senders.modal";
import UserDetail from "./user-detail";
import UserInfo from "./user-info";
import Cookies from "js-cookie";
import GatewayCountryLogsModal from "./GatewayLogsModal";
import AddCreditModal from "./UserManagement/AddCreditModal";
import UserSellPriceModal from "./UserManagement/UserSellPriceModal";
import PaymentLogModal from "../PaymentLog/modal";
import BlackListModal from "./UserManagement/BlackListMemberModal";
import { checkRolePermission } from "../../services/permission";
import { permissionName, permissionType } from "../../config/permission";
import { errorCode } from "../../config/httpResponse";
import MemberCreditWalletModel from "./UserManagement/MemberCreditWalletModel";
import ChangeLogModal from "./UserManagement/components/ChangeLogModal";

const { Content } = Layout;
Moment.globalLocal = false;
const ButtonGroup = Button.Group;
const countryRestrictionsKey = "country-restrictions";
const gatewayCountryKey = "gateway-country";
const sendersKey = "senders";
const gatewayLogs = "gateway-logs";
const addingCredit = "adding-credit";
const paymentLog = "payment-log";
const gatewayGroup = "gateway-group";
const userManageGroup = "user-management-group";
const userSellPrice = "user-sell-price";
const blackList = "blacklist";
const forbiddenCountry = "forbidden-country";
const productWallet = "productWallet";
const saleOwnerUpdate = "saleOwnerUpdate";

class User extends Component {
  state = {
    data: [],
    pagination: {},
    loading: false,
    modalVisible: false,
    modalUserInfoVisible: false,
    salesModalVisible: false,
    userDetail: {},
    countryRestrictionsModalVisible: false,
    currentModal: "",
    dataForModal: {
      memberId: 0,
      memberName: "",
      modalName: "",
      memberBalance: 0,
      detail: {},
    },
    gatewayCountryModalVisible: false,
    countryList: [],
    gatewayList: [],
    revisionList: [],
    adminList: [],

    sendersModalVisible: false,
    gatewayLogsModalVisible: false,
    addingCreditModalVisible: false,
    paymentLogModalVisible: false,
    userSellPriceModalVisible: false,
    blackListModalVisible: false,
    forbiddenCountryVisible: false,
    memberCreditWalletVisible: false,
    filter: {
      country: "",
      status: "",
      revision: "",
      search: "",
    },
    canReadBlacklist: false,
    canReadFbCountry: false,
    isReqSalesBinding: false,
    isEditSaleBinding: false,
    canUpdateSaleOwner: false,
    changeLogModalVisible: false,
  };

  columns = [
    // {
    //   title: "Create Date",
    //   dateIndex: "created",
    //   key: "created",
    //   render: (_, record) => {
    //     return <span>{record.created || "-"}</span>;
    //   },
    //   align: "center",
    // },
    // {
    //   title: "Aging",
    //   dateIndex: "aging",
    //   key: "aging",
    //   render: (_, record) => {
    //     return <span>{record.created ? this.aging(record.created) : "-"}</span>;
    //   },
    //   align: "center",
    // },
    // {
    //   title: "Sales Owner",
    //   dateIndex: "sales",
    //   key: "sales",
    //   render: (_, record) => {
    //     return (
    //       <span>
    //         {record.sale_owner_id ? this.salesOwner(record.sale_owner_id) : "-"}
    //       </span>
    //     );
    //   },
    //   align: "center",
    // },
    // {
    //   title: "Channel",
    //   dateIndex: "channel",
    //   key: "channel",
    //   render: (_, record) => {
    //     return <span>{record.channel || "-"}</span>;
    //   },
    //   align: "center",
    // },
    {
      title: "Country",
      dataIndex: "country",
      key: "country",
      render: (text, record) => {
        if (!record.country) return "-";
        return <span>{this._findCountryName(record.country)}</span>;
      },
      align: "center",
    },
    {
      title: "Name",
      dataIndex: "firstname",
      render: (_, record) => {
        return <span>{record.firstname || "-"}</span>;
      },
      align: "center",
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
    },
    {
      title: "Phone",
      dataIndex: "tel",
      align: "center",
    },
    {
      title: "Avilable Balance",
      dataIndex: "balance",
      render: (text, record) => {
        return <span>${text.toFixed(4)}</span>;
      },
      align: "center",
    },
    {
      title: "Avilable Credit",
      render: (record) => {
        let walletAmount = 0;
        if (record.wallet) {
          walletAmount = Object.keys(record.wallet).length;
        }

        return (
          <span
            className={`customer-offer ${record.wallet ? "active" : ""}`}
            onClick={() => this.moreBtn({ key: productWallet }, record)}
          >
            {walletAmount} Wallets
          </span>
        );
      },
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (text, record) => {
        return (
          <Switch
            checkedChildren="Active"
            unCheckedChildren="Disable"
            checked={!record.is_disabled}
            onChange={(e) => this.toggleStatus(e, record)}
          />
        );
      },
      align: "center",
    },
    {
      title: "Special Price",
      dataIndex: "offers",
      render: (text, record) => {
        return (
          <span
            className={`customer-offer ${
              record.special_offer > 0 ? "active" : ""
            }`}
            onClick={() => this.moreBtn({ key: userSellPrice }, record)}
          >
            {record.special_offer} Offers
          </span>
        );
      },
      align: "center",
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => {
        return (
          <div style={{ textAlign: "right" }}>
            <Tooltip placement="top" title="Request Sales Binding">
              {this.getRequestSalesBindingButton(record)}
            </Tooltip>
            <Divider type="vertical" />

            {record.is_admin_create && !record.first_active ? (
              <span>
                <Tooltip placement="top" title="ส่งอีเมล">
                  <Button
                    type="dashed"
                    shape="circle"
                    icon="file-sync"
                    onClick={() => services.reGenerate(record.id)}
                  />
                </Tooltip>
                <Divider type="vertical" />
              </span>
            ) : (
              ""
            )}

            <ButtonGroup>
              <Tooltip placement="top" title="Stealth Login">
                <Button
                  icon="login"
                  onClick={() => this.stealthLogin(record)}
                />
              </Tooltip>
              <Tooltip placement="top" title="ข้อมูล">
                <Button icon="eye" onClick={() => this._userInfo(record)} />
              </Tooltip>
              <Tooltip placement="top" title="ลบ">
                <Button
                  type="danger"
                  icon="delete"
                  onClick={() => this._delete(record.id)}
                />
              </Tooltip>
            </ButtonGroup>
            <Divider type="vertical" />

            <span>
              <Dropdown overlay={(e) => this.moreMenu(e, record)}>
                <Button shape="circle" icon="more" />
              </Dropdown>
            </span>
          </div>
        );
      },
      align: "center",
    },
  ];
  columnsMobile = [
    {
      title: "",
      dataIndex: "firstname",
      key: "firstname",
      render: (text, record) => {
        return (
          <span>
            <Divider className="my-divider" dashed orientation="left">
              Create Date
            </Divider>
            <div>{record.created}</div>
            {/* <Divider className="my-divider" dashed orientation="left">
              Aging
            </Divider>
            <div>{record.created ? this.aging(record.created) : "-"}</div> */}
            <Divider className="my-divider" dashed orientation="left">
              Channel
            </Divider>
            <div>{record.channel || "-"}</div>
            <Divider className="my-divider" dashed orientation="left">
              Create Date
            </Divider>
            <div>{record.created}</div>

            <Divider className="my-divider" dashed orientation="left">
              Name
            </Divider>
            <div>
              {text} {record.lastname}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Country
            </Divider>
            <div>
              {record.country ? this._findCountryName(record.country) : "-"}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Revision
            </Divider>
            <div className="revision">
              {record.price_sell_group.name || "-"}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Contact
            </Divider>
            <div>
              {record.email}
              <br />
              {record.tel}
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Avilable Balance
            </Divider>
            <div>${record.balance.toFixed(4)}</div>
            <Divider className="my-divider" dashed orientation="left">
              Status
            </Divider>
            <div>
              <Switch
                checkedChildren="Active"
                unCheckedChildren="Disable"
                checked={!record.is_disabled}
                onChange={(e) => this.toggleStatus(e, record)}
              />
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Special Price
            </Divider>
            <div>
              <span
                className={`customer-offer ${
                  record.special_offer > 0 ? "active" : ""
                }`}
                onClick={() => this.moreBtn({ key: userSellPrice }, record)}
              >
                {record.special_offer} Offers
              </span>
            </div>
            <Divider className="my-divider" dashed orientation="left">
              Request Sales Binding
            </Divider>
            {record.sale_owner_id === 0 ? (
              <Button
                type="primary"
                onClick={() => this.handleReqSalesBinding(record)}
              >
                <Icon type="link" />
              </Button>
            ) : null}
            <Divider className="my-divider" dashed orientation="left">
              Action
            </Divider>
            <Row>
              {record.is_admin_create && !record.first_active ? (
                <span>
                  <Tooltip placement="top" title="ส่งอีเมล">
                    <Button
                      type="dashed"
                      shape="circle"
                      icon="file-sync"
                      onClick={() => services.reGenerate(record.id)}
                    />
                  </Tooltip>
                  <Divider type="vertical" />
                </span>
              ) : (
                ""
              )}

              <ButtonGroup>
                <Tooltip placement="top" title="Stealth Login">
                  <Button
                    icon="login"
                    onClick={() => this.stealthLogin(record)}
                  />
                </Tooltip>
                <Tooltip placement="top" title="ข้อมูล">
                  <Button icon="eye" onClick={() => this._userInfo(record)} />
                </Tooltip>
                <Tooltip placement="top" title="ลบ">
                  <Button
                    type="danger"
                    icon="delete"
                    onClick={() => this._delete(record.id)}
                  />
                </Tooltip>
              </ButtonGroup>
              <Divider type="vertical" />

              <span>
                <Dropdown overlay={(e) => this.moreMenu(e, record)}>
                  <Button shape="circle" icon="more" />
                </Dropdown>
              </span>
            </Row>
          </span>
        );
      },
    },
  ];
  moreMenu = (e, d) => {
    return (
      <Menu onClick={(e) => this.moreBtn(e, d)}>
        {/* <Menu.Item key={countryRestrictionsKey}>Country Restrictions</Menu.Item> */}
        <Menu.Item key={paymentLog}>Payment Log</Menu.Item>
        <Menu.SubMenu key={gatewayGroup} title="Gateway Management">
          <Menu.Item key={gatewayCountryKey}>Gateway Route</Menu.Item>
          <Menu.Item key={gatewayLogs}>Gateways Route Logs</Menu.Item>
        </Menu.SubMenu>
        <Menu.SubMenu key={userManageGroup} title="User Management">
          <Menu.Item key={addingCredit}>Adding Credit</Menu.Item>
          <Menu.Item key={sendersKey}>Sender</Menu.Item>
          {/* <Menu.Item key={userSellPrice}>Special Price</Menu.Item> */}
          {/* <Menu.Item key={productWallet}>Member's Credit Wallet</Menu.Item> */}
          {this.state.canReadBlacklist && (
            <Menu.Item key={blackList}>List of Blacklist Number</Menu.Item>
          )}
          {this.state.canReadFbCountry && (
            <Menu.Item key={forbiddenCountry}>
              List of disable country
            </Menu.Item>
          )}
        </Menu.SubMenu>
      </Menu>
    );
  };

  componentWillMount() {
    this.props.fetchMenuAction("user-management", "listing");
    this.setState({ loading: true });
    const canReadBlacklist = checkRolePermission(
      permissionName.CUSTOMER_MANAGEMENT_BLACKLIST,
      permissionType.READ,
    );
    const canReadFbCountry = checkRolePermission(
      permissionName.CUSTOMER_MANAGEMENT_FOBIDDEN_COUNTRY,
      permissionType.READ,
    );

    const canUpdateSaleOwner = checkRolePermission(
      permissionName.CUSTOMER_MANAGEMENT_SALE_OWNER,
      permissionType.UPDATE,
    );

    this.setState({
      canReadBlacklist,
      canReadFbCountry,
      canUpdateSaleOwner,
    });
  }

  async componentDidMount() {
    this.setState({
      countryList: await services._getCountryList(),
      gatewayList: await services._getGatewayList(),
      revisionList: await services._getRevisionList(),
      adminList: await services.getAdminLists(),
      loading: false,
    });

    await this.getListMember();
  }

  salesOwner = (salesId) => {
    const sales = this.state.adminList.find((items) => {
      return salesId === items.id;
    });

    if (!sales) return "-";

    return sales.firstname + " " + sales.lastname;
  };

  setSwitchAllowStatus = async () => {
    if (!this.state.userDetail.fpbf) return;
    let url = Constant.MEMBER_SENDERS_ALLOW_API;
    let params = new URLSearchParams({
      member_id: this.state.userDetail.fpbf.member_id,
      is_allow: this.state.userDetail.fpbf.is_allow === 1 ? 0 : 1,
    });

    url = `${url}?${params.toString()}`;

    const options = {
      url,
      method: "PATCH",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;
    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
      MyModal.info(`บันทึกข้อมูลไม่สำเร็จ`);
      return;
    }

    this.setState({ loading: true });
    this.handleCancelUserInfo();
    MyModal.info(`บันทึกข้อมูลสำเร็จ`);

    const pager = { ...this.state.pagination };
    await this.getListMember(pager.current, 10, this.state.filter);
  };

  toggleStatus = async (status, record) => {
    if (!record.id) return;

    let textConfirm = "ปิดการใช้งาน";
    if (status) {
      textConfirm = "เปิดการใช้งาน";
    }

    MyModal.confirm(
      `ยืนยัน ${textConfirm} ใช่หรือไม่ ?`,
      "",
      async (isConfirm) => {
        if (!isConfirm) {
          return;
        }
        let userDetail = record;
        userDetail.is_disabled = !status;

        await this.setState({ userDetail });

        this.saveUser();
      },
      "ยืนยัน",
      "ยกเลิก",
    );
  };

  stealthLogin = async (record) => {
    this.setState({ loading: true });
    const url = `${Constant.MEMBER_API}/${record.id}/login`;
    const options = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
    };
    let resp;
    let eMsg = `เกิดข้อผิดพลาด ไม่สามารถดำเนินการ Stealth Login ได้ กรุณาลองใหม่อีกครั้ง`;
    let eMsgDetail = "";
    let eFlag = false;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      eFlag = true;
    } else if (resp.data.error) {
      eFlag = true;
      let e = resp.data.error;
      eMsgDetail = `[${e.code}] ${e.name}`;
    }

    if (eFlag) {
      MyModal.error(eMsg, eMsgDetail, () => {
        this.setState({ loading: false });
        window.location.reload();
      });
    } else {
      let passingLoginModal = MyModal.info(
        "กำลังดำเนินการ Stealth Login...",
        "",
        null,
        true,
      );
      setTimeout(() => {
        Cookies.remove(Constant.COOKIES_TOKEN_STEALTH, {
          domain: Constant.COOKIES_DOMAIN,
        });
        Cookies.set(Constant.COOKIES_TOKEN, resp.data.token, {
          domain: Constant.COOKIES_DOMAIN,
        });
        Cookies.set(Constant.COOKIES_OLD_TOKEN, resp.data.old_token, {
          domain: Constant.COOKIES_DOMAIN,
        });
        window.open(Constant.BASE_NWC_URL, "_blank");
        passingLoginModal.destroy();
        this.setState({ loading: false });
      }, 2000);
    }
  };

  _userInfo = (record) => {
    this.setState({
      userDetail: {
        ...record,
        is_postpaid: record.is_postpaid ? 2 : 1,
      },
      modalUserInfoVisible: true,
    });
  };

  handleTableChange = (pagination) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    this.getListMember(pager.current, pagination.pageSize, this.state.filter);
  };

  getListMember = async (
    page = 1,
    limit = 10,
    filter = { country: "", status: "", revision: "", search: "" },
  ) => {
    const url = Constant.MEMBER_API;
    for (const key in filter) {
      if (!filter[key]) {
        delete filter[key];
      }
    }
    const options = {
      url,
      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      params: {
        page,
        limit,
        ...filter,
      },
    };
    let resp;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    let pagination = { ...this.state.pagination };
    pagination.size = "small";
    let d = [];

    if (!resp.data) {
      console.log(resp.data);
    } else if (resp.data.error) {
      console.log(resp.data.error);
    } else {
      d = resp.data.data;
      pagination.total = resp.data.total;
    }

    this.setState({
      loading: false,
      data: d,
      pagination,
    });
  };

  handleSearch = (values) => {
    const pagination = this.state.pagination;
    pagination.current = 1;
    this.setState({
      pagination,
      filter: values,
      loading: true,
    });
    this.getListMember(1, 10, values);
  };

  handleClear = () => {
    const pagination = this.state.pagination;
    pagination.current = 1;
    this.setState({ pagination });
    this.getListMember();
  };

  handleSave = async (values) => {
    if (this.state.isReqSalesBinding) {
      this.handleSaveReqSalesBinding(values);
    } else {
      const userDetail = this.state.userDetail;
      userDetail.updated = moment().format("YYYY-MM-DD HH:mm:ss");
      for (const key in userDetail) {
        if (values[key] !== undefined) {
          userDetail[key] = values[key];

          if (key === "is_postpaid") {
            if (userDetail[key] === 2) userDetail[key] = true;
            else userDetail[key] = false;
          }
        }

        if (key === "notify_member") {
          userDetail["notify_balance"] = Number(values["notify_balance"]);

          if (values["notify_email"]) {
            userDetail["notify_email"] = values["notify_email"].join(",");
          }
        }
      }

      this.setState({
        isReqSalesBinding: false,
        modalVisible: false,
        userDetail,
        modalUserInfoVisible: false,
      });
      this.saveUser();
    }
  };

  handleReqSalesBinding = (record, isEdit) => {
    this.setState({
      isReqSalesBinding: true,
      isEditSaleBinding: isEdit,
      userDetail: record,
      modalVisible: true,
    });
  };

  handleSaveReqSalesBinding = (values) => {
    const { channel, sale_owner_id, note } = values;
    const user = this.state.userDetail;
    const salesPayLoad = {
      member_id: user.id,
      channel,
      sale_owner_id,
      note,
    };

    if (this.state.isEditSaleBinding) {
      // ? trigger this when admin role are about to edit sale order for customer.
      salesPayLoad["status"] = "approved";
    }

    this.setState({
      isReqSalesBinding: false,
      modalVisible: false,
      userDetail: {},
    });
    this.reqSalesOwner(salesPayLoad);
  };

  handleCancel = () => {
    this.setState({ isReqSalesBinding: false, modalVisible: false });
  };

  handleEdit = () => {
    let set = { modalVisible: true };

    if (typeof this.state.userDetail.is_postpaid === "boolean") {
      set = {
        ...set,
        userDetail: {
          ...this.state.userDetail,
          is_postpaid: this.state.userDetail.is_postpaid ? 2 : 1,
        },
      };
    }

    this.setState(set);
  };

  handleAddCredit = async () => {
    this.moreBtn({ key: addingCredit }, this.state.userDetail);
  };

  handleViewUserOffer = async () => {
    this.moreBtn({ key: userSellPrice }, this.state.userDetail);
  };

  handleViewHistory = () => {
    this.setState({ changeLogModalVisible: true });
  };

  handleCancelChangeLog = () => {
    this.setState({ changeLogModalVisible: false });
  };

  handleCancelUserInfo = () => {
    this.setState({ modalUserInfoVisible: false, userDetail: {} });
  };

  handleForbiddenCountry = () => {
    this.props.history.push(
      `/user-management/member-country/${this.state.dataForModal.memberId}`,
    );
  };

  saveUser = async () => {
    const user = this.state.userDetail;
    const fEdit = user.id > 0 ? true : false;

    console.log(user);
    let url = Constant.MEMBER_API;
    if (fEdit) url += "/" + user.id;

    const options = {
      url,
      method: fEdit ? "PUT" : "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
        "Content-Type": "application/x-www-form-urlencoded",
      },
      data: qs.stringify(user),
    };
    let resp;
    let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ${
      fEdit ? "แก้ไข" : "บันทึก"
    }ข้อมูลได้ กรุณาลองใหม่อีกครั้ง`;
    let eMsgDetail = "";
    let eFlag = false;

    try {
      resp = await axios(options);
    } catch (err) {
      resp = err.response;
    }

    let error = resp.data.error;

    if (!resp.data) {
      eFlag = true;
      eMsg = `[1] ${eMsg}`;
    } else if (error) {
      eFlag = true;
      eMsg = `[${error.code}] ${eMsg}`;
      eMsgDetail = error.name;
    }

    if (eFlag) {
      if (error.code === errorCode.WAITING_APPROVE_SALE_BINDING) {
        MyModal.info(error.description, () => {});
      } else {
        MyModal.error(eMsg, eMsgDetail, () => {
          window.location.reload();
        });
      }
    } else {
      this.setState({ loading: true });
      MyModal.info(`${fEdit ? "แก้ไข" : "บันทึก"}ข้อมูลสำเร็จ`);
      const pager = { ...this.state.pagination };
      await this.getListMember(pager.current, 10, this.state.filter);
    }
  };

  reqSalesOwner = async (payload) => {
    let url = Constant.SALES_BINDING_API;
    const opt = {
      url,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
      },
      data: payload,
    };

    let resp;
    let eMsg = `เกิดข้อผิดพลาด ไม่สามารถ Request sales binding ได้ กรุณาลองใหม่อีกครั้ง`;
    let eMsgDetail = "";
    let eFlag = false;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    let error = resp.data.error;

    if (error) {
      eFlag = true;
      eMsgDetail = `[${error.code}] ${error.name}`;
    }

    if (eFlag) {
      if (error.code === errorCode.WAITING_APPROVE_SALE_BINDING) {
        MyModal.info(error.description, () => {});
      } else {
        MyModal.error(eMsg, eMsgDetail, () => {
          window.location.reload();
        });
      }
    } else {
      this.setState({ loading: true });
      MyModal.info("Request sales binding สำเร็จ");
      const pager = { ...this.state.pagination };
      await this.getListMember(pager.current, 10, this.state.filter);
    }
  };

  _create = () => {
    this.setState({
      userDetail: {
        email: "",
        firstname: "",
        lastname: "",
        tel: "",
        company_name: "",
        address: "",
        city: "",
        state: "",
        zip_code: "",
        is_disabled: false,
        country: "",
        sale_owner_id: 0,
        channel: "passive",
        note: "",
        is_postpaid: 1,
        payment_term: 0,
        min_balance_allowed: 0,
      },
      modalVisible: true,
    });
  };

  _delete = (id) => {
    MyModal.confirm(
      "คุณต้องการลบผู้ใช้งาน นี้ ใช่หรือไม่ ?",
      "",
      async (f) => {
        if (!f) return;

        let opt = {
          url: Constant.MEMBER_DELETE_API.replace("[id]", id),
          method: "DELETE",
          headers: {
            Authorization:
              "Bearer " + localStorage.getItem(Constant.SessionKey),
          },
        };
        let resp;
        let eMsg = `เกิดข้อผิดพลาด ไม่สามารถลบผู้ใช้งานได้ กรุณาลองใหม่อีกครั้ง`;
        let eMsgDetail = "";
        let eFlag = false;

        try {
          resp = await axios(opt);
        } catch (err) {
          resp = err.response;
        }

        if (!resp.data) {
          eFlag = true;
        } else if (resp.data.error) {
          eFlag = true;
          let e = resp.data.error;
          eMsgDetail = `[${e.code}] ${e.name}`;
        }

        if (eFlag) {
          MyModal.error(eMsg, eMsgDetail, () => {
            window.location.reload();
          });
        } else {
          this.setState({ loading: true });
          MyModal.info("ลบผู้ใช้งานสำเร็จ");
          const pager = { ...this.state.pagination };
          await this.getListMember(pager.current, 10, this.state.filter);
        }
      },
      "ลบ",
      "ยกเลิก",
    );
  };

  moreBtn = (e, d) => {
    if (e.key === "") return;
    let key;
    switch (e.key) {
      case countryRestrictionsKey:
        key = "countryRestrictionsModalVisible";
        break;
      case gatewayCountryKey:
        key = "gatewayCountryModalVisible";
        break;
      case sendersKey:
        key = "sendersModalVisible";
        break;
      case gatewayLogs:
        key = "gatewayLogsModalVisible";
        break;
      case addingCredit:
        key = "addingCreditModalVisible";
        break;
      case paymentLog:
        key = "paymentLogModalVisible";
        break;
      case userSellPrice:
        key = "userSellPriceModalVisible";
        break;
      case blackList:
        key = "blackListModalVisible";
        break;
      case forbiddenCountry:
        key = "forbiddenCountryVisible";
        break;
      case productWallet:
        key = "memberCreditWalletVisible";
        break;
      case saleOwnerUpdate:
        key = "saleOwnerUpdate";
        break;
      default:
        break;
    }

    this.setState({
      [key]: true,
      currentModal: key,
      dataForModal: {
        memberId: d.id,
        memberName: d.firstname + " " + d.lastname,
        modalName: e.key,
        memberBalance: d.balance,
        detail: d,
      },
    });
  };

  closeModalofMoreBtn = (val) => {
    if (typeof val === "number") {
      const currentMemberIndex = this.state.data.findIndex(
        (m) => m.id === this.state.dataForModal.memberId,
      );
      this.state.data[currentMemberIndex]["balance"] = val;
    }

    this.setState({
      [this.state.currentModal]: false,
      currentModal: "",
      dataForModal: {
        memberId: 0,
        memberName: "",
      },
    });
  };

  _findCountryName = (regionCode) => {
    if (!regionCode) return "-";
    const country = this.state.countryList.find((c) => {
      return c.region_code === regionCode.toUpperCase();
    });
    return country.name || "-";
  };

  getRequestSalesBindingButton = (record) => {
    if (record.sale_owner_id === 0) {
      return (
        <Button
          type="primary"
          shape="circle"
          onClick={() => this.handleReqSalesBinding(record, false)}
        >
          <Icon type="link" />
        </Button>
      );
    }

    if (!this.state.canUpdateSaleOwner) {
      return null;
    }

    return (
      <Button
        type="default"
        shape="circle"
        onClick={() => this.handleReqSalesBinding(record, true)}
      >
        <Icon type="edit" />
      </Button>
    );
  };

  render() {
    let propsTable = {
      className: "my-table customer-table",
      columns: this.columns,
      dataSource: this.state.data,
      rowKey: (record) => record.id,
      pagination: this.state.pagination,
      loading: this.state.loading,
      onChange: this.handleTableChange,
    };
    let propsTableForMobile = Object.assign({}, propsTable);
    propsTableForMobile.className = "my-table-mobile customer-table";
    propsTableForMobile.columns = this.columnsMobile;

    return (
      <Layout>
        <Breadcrumb className="breadcrumb">
          <Breadcrumb.Item>Customer Management</Breadcrumb.Item>
        </Breadcrumb>
        <PageHeader
          style={{
            backgroundColor: "#f0f2f5",
          }}
          title={<h2 style={{ fontWeight: "bold" }}>Customer Management</h2>}
        />
        <Layout className="my-layout">
          <Content className="main-container">
            <div className="main-container-inner">
              <Search
                countryList={this.state.countryList}
                revisionList={this.state.revisionList}
                adminList={this.state.adminList}
                onSearch={this.handleSearch}
                onClear={this.handleClear}
              />
              <Row type="flex" justify="end">
                <Button type="primary" onClick={() => this._create()}>
                  <Icon type="plus" />
                  Add Customer
                </Button>
              </Row>
            </div>
            <Spin spinning={this.state.loading}>
              <Table scroll={{ x: "max-content" }} {...propsTable} />
              <Table {...propsTableForMobile} />
            </Spin>
          </Content>
          <Modal
            visible={this.state.modalUserInfoVisible}
            onCancel={this.handleCancelUserInfo}
            title={
              this.state.userDetail.firstname +
              " " +
              this.state.userDetail.lastname
            }
            footer={[
              <Button key="back" onClick={this.handleCancelUserInfo}>
                ยกเลิก
              </Button>,
            ]}
          >
            <UserInfo
              detail={this.state.userDetail}
              countryList={this.state.countryList}
              onEdit={this.handleEdit}
              onAddCredit={this.handleAddCredit}
              onViewUserOffer={this.handleViewUserOffer}
              onViewHistory={this.handleViewHistory}
              getSalesName={this.salesOwner}
              onSwitchAllowStatus={this.setSwitchAllowStatus}
            />
          </Modal>
          <Modal
            title={
              this.state.isReqSalesBinding
                ? "Request Binding Sales Owner"
                : (this.state.userDetail.id > 0 ? "แก้ไข" : "เพิ่ม") +
                  "ผู้ใช้งาน"
            }
            visible={this.state.modalVisible}
            onCancel={this.handleCancel}
            footer={[
              <Button key="back" onClick={this.handleCancel}>
                ยกเลิก
              </Button>,
              <Button
                key="submit"
                form="userDetail"
                type="primary"
                htmlType="submit"
              >
                {this.state.isReqSalesBinding
                  ? "บันทึก"
                  : this.state.userDetail.id > 0
                    ? "แก้ไข"
                    : "บันทึก"}
              </Button>,
            ]}
            style={{ top: 20 }}
            zIndex={99999}
          >
            <UserDetail
              detail={this.state.userDetail}
              countryList={this.state.countryList}
              adminList={this.state.adminList}
              onSave={this.handleSave}
              isAddUser={!!this.state.userDetail.id === false}
              isReqSalesBinding={this.state.isReqSalesBinding}
              isModalVisible={this.state.modalVisible}
            />
          </Modal>
          <MemberCountryRestrictionsModal
            visible={this.state.countryRestrictionsModalVisible}
            onCancel={this.closeModalofMoreBtn}
            data={this.state.dataForModal}
          />
          <GatewayCountryModal
            visible={this.state.gatewayCountryModalVisible}
            onCancel={this.closeModalofMoreBtn}
            data={this.state.dataForModal}
            countryList={this.state.countryList}
            gatewayList={this.state.gatewayList}
          />
          <SendersModal
            countryList={this.state.countryList}
            data={this.state.dataForModal}
            gatewayList={this.state.gatewayList}
            onCancel={this.closeModalofMoreBtn}
            visible={this.state.sendersModalVisible}
          />
          {this.state.gatewayLogsModalVisible && (
            <GatewayCountryLogsModal
              onCancel={this.closeModalofMoreBtn}
              visible={this.state.gatewayLogsModalVisible}
              gatewayList={this.state.gatewayList}
              countryList={this.state.countryList}
              data={this.state.dataForModal}
            />
          )}
          {this.state.addingCreditModalVisible && (
            <AddCreditModal
              visible={this.state.addingCreditModalVisible}
              data={this.state.dataForModal}
              onCancel={this.closeModalofMoreBtn}
            />
          )}
          {this.state.paymentLogModalVisible && (
            <PaymentLogModal
              visible={this.state.paymentLogModalVisible}
              data={this.state.dataForModal}
              onCancel={this.closeModalofMoreBtn}
            />
          )}
          {this.state.userSellPriceModalVisible && (
            <UserSellPriceModal
              visible={this.state.userSellPriceModalVisible}
              data={this.state.dataForModal}
              countryList={this.state.countryList}
              onCancel={this.closeModalofMoreBtn}
            />
          )}
          {this.state.blackListModalVisible && (
            <BlackListModal
              visible={this.state.blackListModalVisible}
              data={this.state.dataForModal}
              onCancel={this.closeModalofMoreBtn}
            />
          )}
          {this.state.forbiddenCountryVisible && this.handleForbiddenCountry()}
          {this.state.memberCreditWalletVisible && (
            <MemberCreditWalletModel
              onCancel={this.closeModalofMoreBtn}
              visible={this.state.memberCreditWalletVisible}
              data={this.state.dataForModal}
              onWalletUpdate={async () => {
                // Refresh member list to sync wallet data without closing modal
                const pager = { ...this.state.pagination };
                await this.getListMember(pager.current, 10, this.state.filter);
              }}
            />
          )}
          <ChangeLogModal
            visible={this.state.changeLogModalVisible}
            memberId={this.state.userDetail.id}
            onCancel={this.handleCancelChangeLog}
          />
        </Layout>
      </Layout>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
  };
};

export default connect(null, mapDispatchToProps)(User);



// WEBPACK FOOTER //
// ./src/containers/User/index.js